import { login } from '@/auth';
import { ClientConfig } from '@/client-config';

export const headers = {
  'Ocp-Apim-Subscription-Key': ClientConfig.subscriptionKey,
};

export async function fetchWithCredentials(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  return fetch(input, {
    ...init,
    headers: new Headers(init?.headers),
  }).then((response) => {
    if (response.status === 401) {
      login(ClientConfig.loginUrl);
    }
    return response;
  });
}
